import mockdata from '../mockdata'

export const CLEAR = 'ui-settings/customers/CLEAR'
export const LOAD = 'ui-settings/customers/LOAD'
export const SET = 'ui-settings/customers/SET'

export const defaultState = {
  list: [],
  fetched: false,
  fetching: false,
  count: 0,
  total: 0,
  pages: 0
}

export default function reducer (state = defaultState, action = {}) {
  switch (action.type) {
    case CLEAR:
      return {
        ...defaultState
      }

    case LOAD:
      return {
        ...state,
        fetched: false,
        fetching: true
      }

    case SET:
      return {
        ...state,
        fetched: true,
        fetching: false,
        list: action.payload,
        count: action.payload.length,
        total: action.payload.length,
        pages: 1
      }

    default:
      return state
  }
}

export function clearCustomers () {
  return dispatch => dispatch({
    type: CLEAR
  })
}

export function resetCustomers () {
  return dispatch => {
    dispatch(clearCustomers())
    return dispatch(loadCustomers())
  }
}

export function loadCustomers () {
  return (dispatch, getState, api) => {
    dispatch({ type: LOAD })

    return api
      .customers
      .get()
      .then(payload => {
        dispatch({ type: SET, payload })
      })
      .catch(err => {
        console.error(`Error fetching customers: ${err.message}`)
        dispatch(clearCustomers())
      })
  }
}



// WEBPACK FOOTER //
// ./ducks/customers.js